// 在http.js中引入axios
import axios from 'axios' // 引入axios
import md5 from "js-md5";
import cookie from "js-cookie";
import {baseUrl} from "./global_variable";
import router from '@/router'
import { Message } from 'element-ui'

// import QS from 'qs' // 引入qs模块，用来序列化post类型的数据
// import store from '../store/index'
// 请求超时时间
axios.defaults.timeout = 15000
axios.defaults.withCredentials = true
// axios.defaults.headers = true
const APP_KEY = 'mro_gph'

if( cookie.get('GphSeller')){
	console.log(JSON.parse(cookie.get("GphSeller")))
}
axios.interceptors.request.use(
  config => {
		const now = new Date();
		const headTime = now.getFullYear()
			+ (now.getMonth() + 1).toString().padStart(2, '0')
			+ now.getDate().toString().padStart(2, '0')
			+ now.getHours().toString().padStart(2, '0')
			+ now.getMinutes().toString().padStart(2, '0')
			+ now.getSeconds().toString().padStart(2, '0');
    // config.headers.post['Content-Type'] = 'application/json;charset=utf-8';
    let signOne = md5(`50${headTime}${now.getTime()}`)
    config.headers = {
      // sourceMallType: 50,
      // userCode: cookie.get('SysGph') ? JSON.parse(cookie.get("SysGph")).userCode : 'guest',
      // Authorization: config.headers.Authorization||(cookie.get('SysGph') ? 'Bearer '+JSON.parse(cookie.get("SysGph")).token : ''),
      // time: headTime,
      // nonce: now.getTime(),
      // sign: md5(`${APP_KEY}${signOne}`),
      'Content-Type': 'application/json', 'Accept': 'application/json'
    };
    config.params = {
        // t: Date.parse(new Date()),
     ...config.params
    }
    return config
  },
  error => {
    return Promise.error(error)
  })


    //// 响应拦截器
	axios.interceptors.response.use(res=>{
		// if(res.data.code == '059995'){
		// 	setTimeout(() => {
    //     router.push({
    //       path: '/login',
    //       query: {}
    //     })
    //     }, 1000)
		// } else 
    if (res.data.code && res.data.code != "200") {
      Message({
        message: res.data.msg,
        type: 'error',
        duration: 2 * 1000
      })
      return Promise.reject('error')
    } else {
      return res
    }

	})

// const requestUrl = '/';// 测试内部接口
const requestUrl = baseUrl;
// const requestUrl = 'http://192.168.0.119:3000/' // 测试内部接口
// const requestUrl = 'https://www-stage.mrogph.com/' // 预生产内部接口

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function getForm (url, params) {

  return new Promise((resolve, reject) => {
    axios.get(requestUrl + url, params, {
      headers: {
        'Content-Type': 'multipart/form-data;'
      }
    }).then(res => {
      resolve(res.data)
    })
      .catch(err => {
        reject(err.data)
      })
  })
}
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get (url, params) {

  return new Promise((resolve, reject) => {
    axios.get(requestUrl + url, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post (url, params) {

  return new Promise((resolve, reject) => {
    axios.post(requestUrl + url, params, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      resolve(res.data)
    })
      .catch(err => {
        reject(err.data)
      })
  })
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
 export function postLogin (url, params,config) {
  console.log('log', config)
    return new Promise((resolve, reject) => {
      axios.post(requestUrl + url, params, {
        headers: {
          'Authorization': config.Authorization,
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        resolve(res.data)
      })
        .catch(err => {
          reject(err.data)
        })
    })
  }

export function postBuffer (url, params) {

	return new Promise((resolve, reject) => {
	  axios.post(requestUrl + url, params, {
		responseType: 'arraybuffer',
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		}
	  }).then(res => {
		resolve(res.data)
	  })
		.catch(err => {
		  reject(err.data)
		})
	})
  }

export function del (url, params) {

  return new Promise((resolve, reject) => {
    axios.delete(requestUrl + url, params, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      resolve(res.data)
    })
      .catch(err => {
        reject(err.data)
      })
  })
}
/**
 * get方法，对应地址请求的get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function getAddr (url, params) {

  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}

export default {
  get, post, getAddr,del,postBuffer
}



// WEBPACK FOOTER //
// ./src/api/request.js